import ApiRoutes from "../../../constants/api-routes";
import { hneAdminApi } from "../../../service";

export const pdfUpload = async (body) =>
  hneAdminApi.post(`${ApiRoutes.UPLOAD_PDF}`, body);

export const deletePdf = async (key) =>
  hneAdminApi.delete(`${ApiRoutes.DELETE_PDF}/${key}`);
